"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeIndex = void 0;
/**
 * Index for node type (full validator, basic validator or watcher node)
 */
class TypeIndex {
    static get(node) {
        if (node.isFullValidator) {
            return 1;
        }
        if (node.isValidator) {
            return 0.7;
        }
        return 0.3;
    }
}
exports.TypeIndex = TypeIndex;
//# sourceMappingURL=type-index.js.map